
import { computed, defineComponent, getCurrentInstance, ref } from "vue";
import Subtitle from "~/components/Common/Subtitle.vue";
import InfiniteLoadingContent from "~/components/Common/InfiniteLoadingContent.vue";
import ArticleSearchRepository from "~/repositories/ArticleSearchRepository";
import ArticleModel from "~/models/ArticleModel";
import FavButton from "~/components/Common/FavButton.vue";

export default defineComponent({
  name: "UserNewArticles",
  components: {
    Subtitle,
    InfiniteLoadingContent,
    FavButton
  },
  props: {
    userAccountId: {
      type: Number,
      required: true
    },
    limit: {
      type: Number,
      default: 10
    },
    enableInfiniteLoad: {
      type: Boolean,
      default: true
    },
    reader: {
      type: Boolean,
      require: false,
      default: false
    },
    favedArticleIds: {
      type: Array,
      require: false,
      default: () => []
    }
  },
  setup(props) {
    const vm = getCurrentInstance();

    const articles = ref<Array<ArticleModel>>([]);
    const onLoading = async ($state) => {
      try {
        const repo = new ArticleSearchRepository();
        const results = await repo.index({ user_account_ids: [props.userAccountId] }, articles.value.length, props.limit);
        articles.value = articles.value.concat(results);
        if (props.enableInfiniteLoad && results.length > 0) {
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (e) {
        $state.error();
      }
    };

    const showSendDate = computed(() => {
      // HACK: vmの$dayjsがtsのタイプ定義されていないのでignoreで対応
      // @ts-ignore
      return date => vm.proxy.$dayjs(date).format("YYYY年M月D日");
    });

    const imageUrl = (article) => {
      return article.topImage ? `${article.topImage}?size=pc_top` : "/static/image/common/logo_large.png";
    };

    return {
      onLoading,
      articles,
      showSendDate,
      imageUrl
    };
  }
});
